import React from "react";
import { CalDate } from "../../../utilities/functions";

const DateWithoutHours = ({ row }) => {
  return <div>{CalDate(row?.dayDate)}</div>;
};

export default DateWithoutHours;
